import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { profileURL, schoolURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import AddSchool from "../../Templates/Schools/AddSchool/AddSchool";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddSchoolPage({ Edit = false, EditSelf = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();
  const url = `${schoolURL}/${id}`;
  const { data, loading, error } = useFetchWhen(
    EditSelf ? `${profileURL}/school` : url,
    (Edit && contextData?.role == "admin") ||
      (EditSelf && contextData?.role == "school")
  );
  const [school, setSchool] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setSchool(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "schools", data: "" });
  }, []);

  return (
    <AddSchool
      Edit={Edit || EditSelf}
      school={school}
      loading={loading || school == ""}
      url={url}
      EditSelf={EditSelf}
    />
  );
}

export default AddSchoolPage;
